import MultiSelect from "../../../common/MultiSelect";
import { useFormikContext } from "formik";
import countryList from "country-list";
import { SelectChangeEvent } from "@mui/material";
import { createCountryRenderer } from "./MakeCountryFlagOptions";
import { useMemo } from "react";
import { AddSolutionFormValues } from "../../add/form/types";
import { EditSolutionFormValues } from "../../edit/form/types";
import { normaliseToStringArray } from "../../formatting/array-manipulation";

const getAllCountryCodes = (): Array<string> =>
  countryList.getData().map((c) => c.code);

export default function CountryMultiSelect() {
  const { values, setFieldValue, touched, errors } = useFormikContext<
    AddSolutionFormValues | EditSolutionFormValues
  >();
  const fieldName = "country-select";
  const selectedCodes = normaliseToStringArray(values[fieldName]);
  const options = useMemo(() => getAllCountryCodes(), []);

  const updateSelection = (codes: Array<string>) =>
    setFieldValue(fieldName, codes);

  const handleChange = (event: SelectChangeEvent<Array<string>>) => {
    const value = (event.target.value as unknown as Array<string>) ?? [];
    updateSelection(value);
  };

  const handleSelectedChipRemoval = (code: string) => {
    updateSelection(selectedCodes.filter((c) => c !== code));
  };

  const renderOption = useMemo(() => createCountryRenderer("option"), []);
  const renderSelectedChip = useMemo(() => createCountryRenderer("chip"), []);
  const touchedOrNot = Boolean(touched[fieldName]);
  const errorMessage = errors[fieldName] as string;
  const errorOrNot = Boolean(touchedOrNot && errorMessage);

  return (
    <MultiSelect
      id="solution-name-countries"
      label="Country selection"
      options={options}
      selectedValues={selectedCodes}
      onChange={handleChange}
      handleSelectedChipRemoval={handleSelectedChipRemoval}
      renderOption={renderOption}
      renderSelectedChip={renderSelectedChip}
      errors={errorOrNot}
      touchedText={errorOrNot ? errorMessage : undefined}
    />
  );
}
